import {Platform} from 'react-native';

// Import types with type-only imports
import type {
  CameraOptions,
  GalleryOptions,
  UploaderService as UploaderServiceType,
} from './types';

// Import platform-specific implementations
import * as WebUploaderService from './web';

// Export the appropriate implementation based on the platform (renamed to avoid conflict)
const uploaderServiceImpl = WebUploaderService;

export const {galleryLaunch, cameraLaunch} = uploaderServiceImpl;

// Re-export types for consumers using type-only exports
export type {
  CameraOptions,
  GalleryOptions,
  UploaderServiceType as UploaderService,
};
